




















import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { setStorage } from "@common/utils";
import Address from "@/zh-website/src/components/website/Address.vue";
@Component({
  components: {
    Address
  }
})
export default class RegisterStepOne extends Vue {
  @Prop()
  info;

  //status 1 已完成 2 进行中 3未完成
  stepList = [
    {
      step: 1,
      text: "选择业务范围",
      status: 1
    },
    {
      step: 2,
      text: "填写公司基本信息",
      status: 1
    },
    {
      step: 3,
      text: "填写公司经营信息",
      status: 1
    },
    {
      step: 4,
      text: "填写业务联系人信息",
      status: 1
    },
    {
      step: 5,
      text: "完成登记",
      status: 2
    }
  ];
  dataList = [
    {
      data: "",
      label: "业务联系人",
      placeholder: "请输入联系人姓名",
      warn: "请输入业务联系人",
      require: true
    },
    {
      data: "",
      label: "办公电话",
      placeholder: "请输入办公电话，便于联系",
      warn: "请输入办公电话",
      require: true
    },
    {
      data: "",
      label: "手机号",
      placeholder: "请输入手机号",
      warn: "请输入手机号",
      require: true
    },
    {
      data: "",
      label: "电子邮箱",
      placeholder: "请输入电子邮箱地址",
      warn: "请输入电子邮箱",
      require: true
    }
  ];
  options = [
    {
      value: "是",
      label: "是"
    },
    {
      value: "否",
      label: "否"
    }
  ];
  mounted() {
    // 添加用于判断是 c端 还是 b端的 local storage
  }
  onStep() {
    if (this.info.text == "提交失败") {
      this.$emit("onStep", -1);
    } else {
      this.$router.push("/partner/page");
    }
  }
}
